var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Prop, Vue, } from "vue-property-decorator";
import { clone, } from "../utilities/aux";
import RotationDropDown from "../../components/articleattributes/rotationdropdown.vue";
import { isArray, isNumber, } from "../utilities/wsi4_typeguards";
let RotationForm = class RotationForm extends Vue {
    constructor() {
        super(...arguments);
        this.value = [];
    }
    valueChanged() { return this.value; }
    onChange(a) {
        this.value = a;
        this.valueChanged();
    }
    created() { this.value = clone(this.defaultValue, (arg) => isArray(arg, isNumber)); }
};
__decorate([
    Prop({ required: true })
], RotationForm.prototype, "defaultValue", void 0);
__decorate([
    Prop({ required: true })
], RotationForm.prototype, "disabled", void 0);
__decorate([
    Emit()
], RotationForm.prototype, "valueChanged", null);
RotationForm = __decorate([
    Component({
        components: {
            RotationDropDown,
        },
        name: "RotationForm",
    })
], RotationForm);
export default RotationForm;
